import React from 'react';
import { CircularProgress, CircularProgressProps } from '@material-ui/core';

type Props = CircularProgressProps;

export const Loader: React.FC<Props> = (props: Props) => {
  return <CircularProgress {...props} />;
};
